import React, {useEffect, useRef, useState} from 'react';
import BaseAPI from 'web/redux/actions/BaseAPI';
import {Page, Document, pdfjs} from 'react-pdf';
import store from 'web/redux/store';
import {Modal} from 'react-bootstrap';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import {usePrint} from '../hooks/usePrint';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
const reportUrl =
  `${process.env.BASE_URL}/report` || 'http://localhost:8080/report';
/**
 *  @component AssignmentReportPreviewModal
 *  @description 顯示任務報告的 PDF 預覽模態框，並提供列印功能。
 *  @param {Object} assignment - 任務對象，包含 assignmentId 屬性。
 *  @returns {JSX.Element}
 */
export default function AssignmentReportPreviewModal({assignment = {}}) {
  const [reportPath, setReportPath] = useState('');
  const [show, setShow] = useState(false);
  const {print, PrintFrame, clearPrintBlobUrl, download} = usePrint();
  const [disabled, setDisabled] = useState(false);
  const [numPages, setNumPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);

  const getAssignmentDetails = async (assignmentId) => {
    try {
      const token = store.getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        `/app/assignments/details/${assignmentId}`,
        null,
        token,
      );
      return data.result;
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    const getDetailsAndSetPath = async () => {
      if (assignment) {
        const details = await getAssignmentDetails(assignment.assignmentId);
        setReportPath(`${reportUrl}/${details?.reportName}`);
      }
    };
    if (assignment) {
      getDetailsAndSetPath();
    }
    return () => {
      setReportPath('');
    };
  }, [assignment]);

  useEffect(() => {
    const name = reportPath.split('/').pop();
    if (name.endsWith('.pdf')) {
      setShow(true);
    }
  }, [reportPath]);
  const handleClose = () => {
    setShow(false);
    clearPrintBlobUrl();
    setNumPages(1);
    setPageNumber(1);
  };
  const onDocumentLoadSuccess = ({numPages}) => {
    setNumPages(numPages);
  };
  return (
    <Modal show={show} onHide={handleClose} className="pdf-viewer">
      <Modal.Body>
        <div className="text-end row">
          <div className="col-4"></div>
          <div
            className="col-4 d-flex justify-content-center
            align-items-center gap-2"
          >
            <button
              type="button"
              className="btn p-0  border-0"
              onClick={() =>
                setPageNumber((prev) => (prev === 1 ? prev : prev - 1))
              }
            >
              <i class="bi bi-arrow-left-short"></i>
            </button>
            <p className="mb-0">
              Page {pageNumber} of {numPages}
            </p>
            <button
              type="button"
              className="btn p-0  border-0"
              onClick={() =>
                setPageNumber((prev) => (prev === numPages ? prev : prev + 1))
              }
            >
              <i class="bi bi-arrow-right-short"></i>
            </button>
          </div>
          <div className="col-4 d-flex justify-content-end">
            <button
              type="button"
              disabled={disabled}
              className="btn p-0 me-2 border-0"
              onClick={() => download(reportPath)}
            >
              <i className="bi bi-download"></i>
            </button>
            <button
              type="button"
              disabled={disabled}
              className="btn p-0 me-2 border-0"
              onClick={() => {
                print(reportPath);
              }}
            >
              <i className="bi bi-printer"></i>
            </button>
            <button
              type="button"
              className="btn-close btn-cancel"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
            ></button>
            <PrintFrame />
          </div>
        </div>
        <Document
          file={reportPath}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={() => setDisabled(true)}
        >
          <Page {...{pageNumber}} />
        </Document>
      </Modal.Body>
    </Modal>
  );
}
